export default __webpack_public_path__ + "images/FB.3f8b023.png";